module.exports = __webpack_public_path__ + "static/img/bg_14.e1b0b182.png";